(function() {
    'use strict';
    angular
        .module('quantixApp')
        .controller('AxisAmcReportUploadController', AxisAmcReportUploadController);

    AxisAmcReportUploadController.$inject = ['$scope', 'GenericService', 'Principal','GenericServiceNew', 'CompanyReportService', 'FinancialSensitivityService','$http','$timeout', '$state', '$uibModal', '$filter', '$window', '$sce', 'AuthKeycloak', 'Upload'];
    function AxisAmcReportUploadController($scope, GenericService, Principal,GenericServiceNew, CompanyReportService,FinancialSensitivityService, $http,$timeout, $state, $uibModal, $filter, $window, $sce, AuthKeycloak,Upload) {
    	$scope.isExternal= false;
        $scope.showError = false;
        $scope.searchType = 'companyName';
		$scope.newCompanyRequest = {};
		$scope.companyObj = {};
		$scope.companyDetails = {};
		$scope.showCompanyDetails = false;
		$scope.responseMessage = '';
		$scope.selectedType = 'Select Template Type';
		$scope.companyDownloads = [];
		$scope.recentViewedCompanies = [];
		$scope.filtercompanies = []
		$scope.showManagedSubscriptionPage = false;
		var downloadReportGrid = '';
		$scope.isStandard = true;
		$scope.allTemplates = {};
		$scope.sampleReports = [];
		$scope.isPlusSubscribed = false;
		$scope.isCompInfoAdmin = false;
		$scope.successMessage = '';
		$scope.samples = [{ id: 1, templateName: 'Lite' },
			{ id: 2, templateName: 'Advanced' },
			{ id: 3, templateName: 'Comprehensive' }
		]
		$scope.showNewDataFilter = false;
		$scope.toggleTemplateSelection = function() {
			$scope.selectedType = 'Select Template Type';
			if($scope.isStandard) {
				$scope.sampleReports = $scope.allTemplates.standard;
			} else {
				$scope.sampleReports = $scope.allTemplates.custom;
			}
		}

        $scope.searchFilterForCompanyProfile = function (typedthings) {
            //$scope.showError = false;
            $scope.companyCode = "";
			if (typedthings == "cleanData") {
				$scope.companies = null;
			} else {
				if(typedthings.length > 1) {
					GenericServiceNew
					.getCompaniesListByNameForCompanyReport(typedthings)
					.then(function (data) {
							$scope.companies = data;
							if ($scope.companies.length == 0) {
								$scope.showError = true;
								$scope.errorMessages = "Please select a company from the suggested list.";
							} else {
								$scope.showError = false;
							}
						}, function (errordata) {
							$scope.showError = true;
							$scope.errorMessages = "Error while searching company!";
					});
				}
			}
        }
        
        $scope.selectCompany = function (companyObj) {
			$scope.companyObj = companyObj;
			var arraspersector = [];
			var i = 0;
			
				if(companyObj.companyFlag == "Manufacturing"){

					for (i = 0; i < $scope.actualcustomlist.length; i++) {
						
						if(JSON.parse($scope.actualcustomlist[i].templateJson).template.selectedSector == "G" || JSON.parse($scope.actualcustomlist[i].templateJson).template.selectedSector == "M"){
							arraspersector.push($scope.actualcustomlist[i]);
						}
					  } 

				}else{
					
					for (i = 0; i < $scope.actualcustomlist.length; i++) {
						
						if(JSON.parse($scope.actualcustomlist[i].templateJson).template.selectedSector == "G" || JSON.parse($scope.actualcustomlist[i].templateJson).template.selectedSector != "M"){
							arraspersector.push($scope.actualcustomlist[i]);
						}
					  } 


				}

				
				$timeout(
					function(){
						$scope.allTemplates.custom = arraspersector;
						$scope.toggleTemplateSelection();
					},100
				)
				

			}

		

        $scope.searchCompany = function (reportType, templateJson, event,
			companyName) {
				$scope.showCompanyDetails = false;
				
				var promise = CompanyReportService
					.getCompanyDetails($scope.companyObj.companyCode);
				promise
					.then(function (data) {
						// $scope.showCompanyDetails = true;
						var companyDetails = data.data;
						var companyPeers = companyDetails.peersBenchmark == null ? [] : companyDetails.peersBenchmark.split('$');
						var remainigPeers = companyPeers.slice(1);
						var arr = companyDetails.industry != null ? companyDetails.industry.split('$$$$') : [];
						var industryLevel = [];
						arr.forEach(function (e) {
								var temp = e.split('_');
								var obj = {};
								obj.name = temp[0];
								obj.id = temp[1];
								if (temp[1] == 5) {
									companyDetails.fifthlevelind = temp[0];
								} else if (temp[1] == 4) {
									companyDetails.forthlevelind = temp[0];
								}
								industryLevel
									.push(obj);
					});
					var selectedType = {};
					if(templateJson) {
						selectedType = templateJson;
					} else {
						selectedType = $scope.selectedType && $scope.selectedType != "Select Template Type" ? JSON.parse($scope.selectedType) : undefined;
					}
					$scope.companyObj.irsIndustryNames = $scope.irsNameList;
					$scope.customeJson = (selectedType != null && selectedType != undefined)  ? JSON.parse( selectedType.templateJson) : undefined;
					if((selectedType ? selectedType.id == '3' : reportType == '3') || 
							(($scope.customeJson != null && $scope.customeJson != undefined) ?  ($scope.customeJson != null && $scope.customeJson.template.crisilAnalytics ? $scope.customeJson.template.crisilAnalytics.fsm : false) : false)){
					var promise1 = FinancialSensitivityService
					.getSelectedCompanyDetails($scope.companyObj.companyCode, 'FSM_ALL')
					promise1
					.then(function (data1) {
					
		                	$state.go('companyreportdetails', {
								'companyDetails': data.data,
								'companyObj': $scope.companyObj,
								'companyPeers': companyPeers,
								'remainigPeers': remainigPeers,
								'industryLevel': industryLevel,
								'reportType': reportType ? reportType : selectedType.id,
								'templateJson': selectedType ? selectedType.templateJson : undefined,
								'fsmData':data1,
							})
		                       

					},
		                    
		                    function (errordata) {});
					}else{
						$state.go('companyreportdetails', {
							'companyDetails': data.data,
							'companyObj': $scope.companyObj,
							'companyPeers': companyPeers,
							'remainigPeers': remainigPeers,
							'industryLevel': industryLevel,
							'reportType': reportType ? reportType : selectedType.id,
							'templateJson': selectedType ? selectedType.templateJson : undefined,
							'fsmData':null,
						})
					}
						
					
					//})
				}, function (errorData) {
					$scope.showCompanyDetails = false;
				});
		}

		$scope.userGridCompletion = function(event) {
            downloadReportGrid = event.target;
            downloadReportGrid.validateNow();
		}
		

		$scope.closeAlert = function() {
			$scope.newCompanyRequest = {};
			$scope.successMessage = '';
		}

		$scope.changeFormat = function(format) {
			$scope.selectedFormat = format;
		}

		$scope.getCompanyDownloads = function() {
			CompanyReportService.getAxisAmcreportUploads().then(
				function(successData) {
					$scope.downloadReportGrid = {
                        //dataProvider : $scope.subscriptionsObj.subscriptionLimit ? response.users : [],
                        dataProvider : successData,
                        delegate : $scope
                    };
					//$scope.companyDownloads = successData;
			}, function(errorData) {

			})
		}

		var downloadDto = {}
		
		$window.openModal = function(reportName, reportType, companyName, downloadDate) {
			
			downloadDto = {
				companyName: companyName,
				downloadDate: downloadDate,
				fileFormat: reportName,
				newData: "",
				reportType: reportType,
			}
			console.log(downloadDto)
			$scope.message ={
				state: 'download',
				title: 'Report download',
				message: 'Would you like to re-download the report as generated on '+$filter('date')(downloadDto.downloadDate,'dd-MMM-yyyy')
			};
			$uibModal.open({
				templateUrl: 'app/companyReport/confirmationModals/confirmationmodal.html',
				size: 'sm',
				scope: $scope,
				controller: 'CustomFilterController'
			})
		}

		$scope.applyFiltersModal = function() {
			$uibModal.open({
				templateUrl: 'app/companyReport/customFilters/customfilter.html',
				size: 'md',
				scope: $scope,
				controller: 'ConfirmationModalController'
			})
		}

		$scope.applyFilters = function() {
			CompanyReportService.applyFilters($scope.filters).then(function(response) {
                $scope.downloadReportGrid = {
					dataProvider : response,
					delegate : $scope
				};
			}, function(error) {});
		}

		$scope.getDate = function(rowData, column) {
            return $filter('date')(rowData.reportDate,'dd-MMM-yyyy H:mm:ss');
		}
		
		$scope.getReportType = function(rowData, column) {
			return rowData.reportType+ $scope.getReportFormat(rowData);
		}
		
		$scope.getNewDataLabel = function(rowData, column) {
			return rowData.newData == 'No new data available' ? rowData.newData : rowData.newData + '<span class="load" onClick= "generateReport(this)"><i class="fa fa-download hover upload-fail grid-svg" title="Download New Report" ></i>';
		}

		$scope.shouldNotify = '';
		$window.deleteOrNotifyReport = function(item, shouldNotify) {
			console.log(item.parentNode.component.data);
			$scope.companyObj = item.parentNode.component.data;
			downloadDto = item.parentNode.component.data;
			$scope.shouldNotify = shouldNotify;
			// console.log(downloadDto)
			$scope.message ={
				state: 'delete',
				title: shouldNotify == 'Y' ? 'Notify Report' : 'Delete Report',
				message: shouldNotify == 'Y' ? 'Are you sure you want to notify the client ?' : 'Are you sure you want to delete the report ?'
			};
			$uibModal.open({
				templateUrl: 'app/companyReport/confirmationModals/confirmationmodal.html',
				size: 'sm',
				scope: $scope,
				controller: 'CustomFilterController'
			})
		}

		$scope.getCompanyReportTemplates = function() {
			var subscription = [];
			GenericService.getUserModuleAccessData().then(function (result) {
				if(AuthKeycloak.authz.hasRealmRole('ROLE_COMPANY_REPORT_ADMIN')) {
					subscription.push('AMC');
				}
				subscription
				CompanyReportService.getCompanyReportTemplates(subscription).then(
						function(successData) {
							$scope.allTemplates = successData;
							$scope.actualcustomlist = $scope.allTemplates.custom;
							if($scope.allTemplates.custom.length > 0 && $scope.allTemplates.standard.length == 0) {
								$scope.isStandard = false;
								
							}
							$scope.rmeMail = successData.rmeMail;
							for(var i = 0; i < successData.standard.length;i++){
								if(successData.standard[i].templateName == "Lite"){
									successData.standard[i].templateJsonString = "Company snapshot covering basic financial and non-financial parameters";
		
								}
								if(successData.standard[i].templateName == "Advanced"){
									successData.standard[i].templateJsonString = "Advanced report covering alternate data indicators in addition to basic parameters";
								}
								if(successData.standard[i].templateName == "Comprehensive"){
									successData.standard[i].templateJsonString = "A comprehensive report including CRISIL IP models and outlook in addition to advance report parameters";
								}
								
							}
							if($scope.isStandard) {
								$scope.sampleReports = $scope.allTemplates.standard;
							} else {
								$scope.sampleReports = $scope.allTemplates.custom;
							}
					}, function(errorData) { })
			});
		}

    $scope.fileUpload = null;

    $scope.uploadReport = function(file) {
        $scope.closeAlert();
        var fd = new FormData();
        fd.append('file', file); 
        fd.append('companyCode', $scope.companyObj.companyCode);
        fd.append('companyName', $scope.companyObj.companyName);
        var reporType = JSON.parse($scope.selectedType);
        fd.append('reportType', reporType.id);
        fd.append('reportName', reporType.templateName);
        CompanyReportService.uploadAxisAmcReport(fd).then(function(response) {
                    $scope.successMessage = response.data;
                    $scope.fileUpload = null;
                    $scope.message = response.data;
					$scope.getCompanyDownloads();
            }, function(error) {
                    $scope.isError = true;
                    $scope.message = error.data;
                    $scope.fileUpload = null;
            }
        );  
    }

    $scope.getNotifyLabel = function(rowData, column) {
        return  rowData.notifyClient == 'Y' ? '<span class="load" onClick= "deleteOrNotifyReport(this, \'Y\')" data-toggle="modal" data-target="#confirmModal"><i class="fa fa-bell hover upload-color grid-svg" title="Notify Client" ></i></span>' : '<span class="load" onClick= "deleteOrNotifyReport(this, \'Y\')" data-toggle="modal" data-target="#confirmModal"><i class="fa fa-bell hover upload-success grid-svg" title="Notify Client" ></i></span>';
    }

    $scope.getDeleteLabel = function(rowData, column) {
        return '<span class="load" onClick= "deleteOrNotifyReport(this, \'N\')" data-toggle="modal" data-target="#confirmModal"><i class="fa fa-trash hover grid-svg" title="Delete Report" ></i></span>';
    }

	$scope.confirmDeleteOrNotify = function() {
		if($scope.shouldNotify == 'Y') {
			CompanyReportService.notifyAxisAmcReport(downloadDto).then(function(response) {
				$scope.getCompanyDownloads();
				$scope.successMessage = response.data;
			}, function(error) {
			});  
		} else {
			CompanyReportService.deleteAxisAmcReport(downloadDto).then(function(response) {
				$scope.getCompanyDownloads();
				$scope.successMessage = response.data;
			}, function(error) {
			});
		}
	}

	// $scope.uploadReportStatus = function()
	// {
	// 	$scope.successMessage = response.data;
	// 	$scope.successMessagebool = true;
	// 	$timeout(function(){
	// 		$scope.successMessagebool = false;
	// 	},1000);
	// }

    $scope.getCompanyDownloads();
    $scope.getCompanyReportTemplates();
	$window.scroll(0,0);
    }
    })();
    	